<template>
    <div
            class="ui-evaluation-body"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
    >
        <div
                class="list"
                v-for="(item, index) in reviewList"
                v-if="reviewList.length > 0"
        >
            <div>
					<span>
						{{ item.member_name }}
						<span class="common-score-wrapper"><i class="iconfont front" :style="{width:item.o2o_fuwu_order_evaluate_score/5*100+'%'}"></i><i class="iconfont back"></i></span>
					</span>

                <span>{{ $moment.unix(item.o2o_fuwu_order_evaluate_time).format('YYYY-MM-DD HH:mm') }}</span>
            </div>
            <p v-if="item.o2o_fuwu_order_evaluate_content">{{ item.o2o_fuwu_order_evaluate_content }}</p>
            <p v-else>无评价信息</p>
        </div>

        <div class="list-empty" v-if="reviewList.length <= 0">
            <p>暂无评价</p>
        </div>
    </div>
</template>

<script>
import { getReviewList } from '../../../api/fuwuOrganization'
export default {
  name: 'Evaluate',
  data () {
    return {
      reviewList: []
    }
  },
  created () {
    this.getReviewList(false)
  },
  methods: {
    loadMore () {
      this.loading = true
      this.page = ++this.page
      if (this.page <= this.total) {
        this.loading = false
        this.getReviewList(true)
      }
    },
    getReviewList (ispush) {
      getReviewList({ page: 1, per_page: 10 }, this.$route.query.organization_id).then(res => {
        if (res) {
          if (ispush) {
            this.reviewList = this.reviewList.concat(res.result.evaluate_list)
          } else {
            this.reviewList = res.result.evaluate_list
          }
          if (res.hasmore) {
            this.loading = false
          } else {
            this.loading = true
          }
          this.total = res.page_total
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
    .ui-evaluation-body {
        padding: 0 0.75rem;
        background: rgba(255, 255, 255, 1);
				min-height:2rem;
        .list {
            padding: 0.75rem 0;
            border-bottom: 0.5px solid rgba(232, 234, 237, 1);
            color: #333;
            font-size:0.7rem;
            div {
                overflow: hidden;
                padding-bottom:0.75rem;
                display: flex;
                justify-content: space-between;
                align-content: center;
                align-items: center;
                span {
                    &:first-child {
                        display: flex;
                        justify-content: space-around;
                        align-content: center;
                        align-items: center;
                        span {
                            margin-left:0.75rem;
                            color: #ffffff;
                            font-size:0.6rem;
                        }
                    }
                    &:last-child {
                        color: #999999;
                        font-size:0.6rem;
                    }
                    &.good-review {
                        background: #fc2e39;
                        width:1.8rem;
                        height:0.8rem;
                        text-align: center;
                        background-size: cover;
                        line-height:0.8rem;
                        border-radius:0.4rem;
                    }
                    &.medium-review {
                        background: #e93b3d;
                        width:1.8rem;
                        height:0.8rem;
                        text-align: center;
                        background-size: cover;
                        line-height:0.8rem;
                        border-radius:0.4rem;
                    }
                    &.bad-review {
                        background: #c3c3c3;
                        width:1.8rem;
                        height:0.8rem;
                        text-align: center;
                        background-size: cover;
                        line-height:0.8rem;
                        border-radius:0.4rem;
                    }
                }
            }
            p {
                padding: 0;
                margin: 0;
                flex-basis: 100%;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }
        }
        .list-empty {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            img {
                width:2.75rem;
            }
            p {
                color: #999999;
                font-size:0.7rem;
                padding: 0;
                margin: 0;
                font-weight: normal;
            }
        }
    }
</style>
